import { createSlice } from "@reduxjs/toolkit";
import { createPayoutRequest, fetchPayoutRequestById, fetchPayoutRequests, updatePayoutRequest } from "./payoutRequestsThunk";


const initialState = {
  data: [],
  current: null,
  loading: false,
  error: null,
};

const payoutRequestsSlice = createSlice({
  name: "payoutRequests",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // GET all
      .addCase(fetchPayoutRequests.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPayoutRequests.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchPayoutRequests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // GET by ID
      .addCase(fetchPayoutRequestById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPayoutRequestById.fulfilled, (state, action) => {
        state.loading = false;
        state.current = action.payload;
      })
      .addCase(fetchPayoutRequestById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // POST create
      .addCase(createPayoutRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createPayoutRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.data.push(action.payload);
      })
      .addCase(createPayoutRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // PUT update
      .addCase(updatePayoutRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePayoutRequest.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.data.findIndex((r) => r.id === action.payload.id);
        if (index !== -1) {
          state.data[index] = action.payload;
        }
      })
      .addCase(updatePayoutRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default payoutRequestsSlice.reducer;
